import { useQuery } from '@tanstack/react-query';

import type { EventStudent } from '~entities/student/modal/event-student';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetEnrolledActiveStudentsByEventIdParams {
  eventId: string;
}

export const getActiveStudentsByEventIdAPI = async (
  params: GetEnrolledActiveStudentsByEventIdParams,
) => {
  const response = await baseAPI.get<Array<EventStudent>>(
    `/students/${params.eventId}/event/active`,
  );
  return response.data;
};

export const getActiveStudentsByEventIdOptions = (
  params: GetEnrolledActiveStudentsByEventIdParams,
) => ({
  queryKey: [KEYS.STUDENTS, params.eventId],
  queryFn: () => getActiveStudentsByEventIdAPI(params),
});

export const useGetActiveStudentsByEventId = (
  params: GetEnrolledActiveStudentsByEventIdParams,
) => {
  return useQuery(getActiveStudentsByEventIdOptions(params));
};
